<template>
  <div>
    <Navbar></Navbar>

    <div class="container mt-3 mt-lg-5">

      <!-- TITLE-->
      <div class="row mb-3">
        <div class="col-md-12">
          <p class="overline text-primary mb-1">{{ user.data.displayName }}</p>
          <vue-aos animation-class="animate__animated animate__flipInX">
            <h1 class="typography-headline-lg fw-500">Gradients</h1>
          </vue-aos>
        </div>
      </div>

      <!-- NEW GRADIENTS SECTION -->
      <UserGradientsList :gradients="gradients"></UserGradientsList>

    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/includes/Footer";
import Navbar from "@/components/includes/Navbar";
import {mapGetters} from 'vuex'
import firebase from 'firebase/app'
import 'firebase/firestore'
import UserGradientsList from "@/components/users/gradients/UserGradientsList";
import VueAos from 'vue-aos'

export default {
  name: 'UserGradients',
  metaInfo: {
    title: 'My Gradients'
  },
  components: {UserGradientsList, Navbar, Footer, VueAos},
  computed: {
    ...mapGetters(['user'])
  },
  data() {
    return {
      gradients: [],
      db: firebase.firestore(),
    }
  },
  mounted() {
    this.fetchGradients()
  },
  methods: {
    async fetchGradients() {
      try {
        let gradientsSnap = this.db
            .collection('users').doc(this.user.data.uid).collection('gradients')

        gradientsSnap = await gradientsSnap
            .orderBy('createdAt', "desc")
            .get()

        this.lastGradient = gradientsSnap.docs[gradientsSnap.docs.length - 1]
        this.gradients = gradientsSnap.docs.map(doc => {
          return {id: doc.id, ...doc.data()}
        })

      } catch (e) {
        console.log(e.message)
      }
    },
  }
}
</script>